export default __webpack_public_path__ + "static/media/subramani.028087af.jpeg";